module.exports = __webpack_public_path__ + "static/media/La FRENCH TECH Logo.3094161f.svg";